export default {
  buttonCalendarContainer: {
    font: "300 13px 'Roboto',sans-serif",
    backgroundColor: '#fff',
    border: '1px solid #d8d8d8',
    borderRadius: '30px',
    textAlign: 'left',
    '& > div': {
      padding: '0px 10px',
      cursor: 'pointer',
    },
    '& > button':{
      height:'40px',
    },
    '& button':{
      padding:0,
      border:'none',
      '&:hover':{
        background:'transparent',
        '& span':{
          color:data => [data.mainColor,'!important']
        }
      },
      '& span': {
        pointerEvents: 'none',
        '&:lang(ar)':{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          '& > span':{
            marginRight: '0',
            marginLeft: '5px',
          }
        }
      }
    },
    '&:lang(ar)':{
      textAlign:'right',
      direction:'rtl'
    },
  },
  searchOptionsCalendar: {
    color: '#666',
    marginTop: '16px',
    paddingTop: '13px'
  },
  calendarSvg: {
    height: '20px',
    width: '20px',
    position:'absolute',
    top:'50%',
    left:'5%',
    marginTop:'-10px',
    pointerEvents: 'none',
    fill: data => data.mainColor,
    '@media(min-width:961px)': {
      left:'10%',
    },
    '&:lang(ar)':{
      marginRight: "0",
      marginLeft: "5px"
    }
  },
  bestSalesMobil: {
    font: "300 13px 'Roboto',sans-serif",
    color: '#666'
  },
  buttonCalendarContainerDesktop: {
    display: 'table-cell',
    verticalAlign: 'middle',
    width: '170px',
    borderLeft: '1px solid #d8d8d8',
    borderRight: '1px solid #d8d8d8',
    background: '#fff',
    padding: '0',
    '@media(min-width:801px)': {
      width: '200px',
    },
    '& > button': {
      height: '50px',
      width: '100%',
      padding: '0 10px 0 40px',
      font: "13px 'Roboto',sans-serif",
      textAlign: 'left',
      color: data => data.mainColor,
      position: 'relative',
      '@media(min-width:961px)': {
        padding: '0 20px 0 50px',
      },
      '& > span': {
        display: 'block',
        pointerEvents: 'none',
        '& > $calendarSvg': {
          width: '20px',
          height: '20px',
          position: 'absolute',
          left: '10px',
          top: '50%',
          marginTop: '-10px',
          '&:lang(ar)':{
            left:'auto',
            right:'10px'
          },
          '@media (min-width:961px)': {
            left: '17px',
            '&:lang(ar)':{
              right:'17px'
            },
          }
        },
        '& > span:last-of-type': {
          marginLeft: '5px',
          pointerEvents: 'none',
          '&:lang(ar)':{
            marginLeft: "0",
            marginRight: "5px"
          }
        }
      },
      '&:after': {
        content: "''",
        position: 'absolute',
        left: '20%',
        right: '20%',
        background: 'transparent',
        bottom: '0',
        height: '3px',
        WebkitTransition: '0.3s',
        OTransition: '0.3s',
        transition: '0.3s'
      },
      '&:hover:after': {
        left: '0',
        right: '0',
        background: data => data.mainColor
      },
      '&:lang(ru)': {
        height: 'auto',
        minHeight: '50px',
        padding: '5px 25px 5px 45px'
      },
      '&:lang(ar)':{
        paddingRight: "45px",
        paddingLeft: "25px",
        textAlign: "right"
      }
    }
  },
  calendarCloseButton: {
    top: '11px',
    right: '14px',
    position: 'fixed',
    zIndex: '99999',
    background: 'none',
    cursor: 'pointer',
    color: data => data.mainColor,
    border: '0',
    fontSize: '15px',
    '&:lang(ar)':{
      right: "auto",
      left: "14px",
      '@media(min-width:801px)': {
        right: "auto",
        left: "15px"
      }
    },
    '@media(min-width:801px)': {
      top: '15px',
      right: '15px',
      position: 'absolute',
      fontSize: '20px'
    }
  },
  buttonCalendarWI:{
    display:'flex',
    alignItems:'baseline',
    border: 'none',
    '& > div':{
      marginRight:'5px',
      '& button':{
        height:'40px',
        '& > span':{
          position: 'relative',
          paddingLeft: '25px',
          '&:lang(ar)':{
            paddingLeft: '0',
            paddingRight: '25px',
            marginLeft: '5px',
          },
          '& > span':{
            position: 'absolute',
            left: '0',
            top: '50%',
            lineHeight: '1px',
            marginRight: 'auto',
            '&:lang(ar)':{
              left: 'auto',
              right: '0',
            }
        }
        }
      }
    }
  },
  buttonCalendarDatepicker:{
    background:'red'
  }
};